<template>
  <div class="audio-btn-layout" style="position: relative">
    <canvas id="bar-layer" ref="canvasBar" :width="width" :height="height"></canvas>
    <canvas id="bg-layer" ref="canvasBg" :width="width" :height="width"></canvas>
  </div>
</template>

<script>
import audioBg from '@/assets/img/audio-btn-bg.png'
export default {
  props: ['width', 'height', 'audioStream'],
  data() {
    return {
      drawVisual: null,
      audioCtx: null,
      analyser: null,
      source: null,
      dataArrayAlt: null,
      audioBg: audioBg,
    }
  },
  mounted() {
    let bgCanvas = this.$refs.canvasBg
    let bgCtx = bgCanvas.getContext('2d')

    let bgWidth = bgCanvas.width
    let bgHeight = bgCanvas.height

    let barCanvas = this.$refs.canvasBar
    let barCtx = barCanvas.getContext('2d')

    let barWidth = barCanvas.width
    let barHeight = barCanvas.height

    let audioBg = new Image()
    // audioBg.src = require('@/assets/img/audio-btn-bg.png')
    audioBg.src = this.audioBg
    audioBg.onload = function () {
      let oc = document.createElement('canvas'),
        octx = oc.getContext('2d')

      bgCanvas.width = 40 // destination canvas size
      bgCanvas.height = (bgCanvas.width * audioBg.height) / audioBg.width

      let cur = {
        width: Math.floor(audioBg.width * 0.5),
        height: Math.floor(audioBg.height * 0.5),
      }

      oc.width = cur.width
      oc.height = cur.height

      octx.drawImage(audioBg, 0, 0, cur.width, cur.height)

      while (cur.width * 0.5 > 50) {
        cur = {
          width: Math.floor(cur.width * 0.5),
          height: Math.floor(cur.height * 0.5),
        }
        octx.drawImage(oc, 0, 0, cur.width * 2, cur.height * 2, 0, 0, cur.width, cur.height)
      }

      bgCtx.drawImage(oc, 0, 0, cur.width, cur.height, 0, 0, bgCanvas.width, bgCanvas.height)
    }
    // audioBg.src = require('@/assets/img/audio-bg.png')
    barCtx.clearRect(0, 0, barWidth, barHeight)

    let drawAlt = () => {
      this.drawVisual = requestAnimationFrame(drawAlt)

      barCtx.clearRect(0, 0, barWidth, barHeight)

      if (this.analyser !== null && this.analyser !== undefined) {
        this.analyser.getByteFrequencyData(this.dataArrayAlt)

        let sum = this.dataArrayAlt.reduce((sum, currValue) => {
          return sum + currValue
        })

        let tempHeight = ((sum / this.dataArrayAlt.length) * barHeight) / 100

        let alpha = (tempHeight / barHeight).toFixed(1)

        let positionY = bgHeight - tempHeight
        let positionX = this.width / 5
        barCtx.fillStyle = 'rgba(255,70,79,' + alpha + ')'
        let temp = (barHeight / 250) * 50
        barCtx.fillRect(positionX, positionY < temp ? temp - 4 : positionY - 4, 50, tempHeight)
      }

      // barCtx.fillStyle = 'rgba(255,197,66,' + alpha + ')'
      // barCtx.fillRect(85, positionY, 80, tempHeight)
      // bgCtx.drawImage(audioBg, 0, 0, 30, 30)
    }

    drawAlt()
  },
  methods: {
    makeAudioAnalyser(audioStream) {
      // let ctx = this
      this.audioCtx = new (window.AudioContext || window.webkitAudioContext)()
      this.analyser = this.audioCtx.createAnalyser()
      // analyser.smoothingTimeConstant = 0.85;
      this.source = this.audioCtx.createMediaStreamSource(audioStream)

      this.source.connect(this.analyser)

      if (!this.analyser) return

      // Default 2048, 2의 거듭제곱으로 클수록 주파수 영역이 세밀하지만 느려진다.
      this.analyser.fftSize = 32

      let bufferLengthAlt = this.analyser.frequencyBinCount
      this.dataArrayAlt = new Uint8Array(bufferLengthAlt)
    },
    stopAnimationFrame() {
      cancelAnimationFrame(this.drawVisual)
    },
  },
  beforeDestroy() {
    this.stopAnimationFrame()
    // if (this.checkFailAudioInterval !== null) {
    //   clearInterval(this.checkFailAudioInterval)
    //   this.checkFailAudioInterval = null
    // }
  },
  watch: {
    audioStream(val) {
      if (val && val.getAudioTracks() && val.getAudioTracks().length > 0) this.makeAudioAnalyser(val)
      // console.log('audioStream ? ', val)
    },
  },
}
</script>

<style scoped>
canvas {
  position: absolute;
  top: 0;
  left: 0;
}
#bar-layer {
  z-index: 1;
}
#bg-layer {
  z-index: 2;
}
</style>
